import Vue from 'vue';
import VueI18n from 'vue-i18n';

const translations = {
	en: {
		followOnInstagram: 'Follow us on Instagram',
		search: 'Search',
		T: 'P',
		showOnMap: 'Show on map',
		showSelection: 'Show selection',
		sellsFollowingProduktLines: 'Sells following product lines',
		showMore: 'Show more',
		newsArticle: 'News',
	},
	da: {
		followOnInstagram: 'Følg os på Instagram',
		search: 'Søg',
		T: 'T',
		showOnMap: 'Find vej',
		showSelection: 'Se udvalg',
		sellsFollowingProduktLines: 'Forhandler følgende serier:',
		showMore: 'Vis flere',
		newsArticle: 'Nyhed',
	},
	de: {
		followOnInstagram: 'Følg os på Instagram',
		search: 'Søg',
		T: 'T',
		showOnMap: 'Find vej',
		showSelection: 'Se udvalg',
		sellsFollowingProduktLines: 'Forhandler følgende serier:',
		showMore: 'Vis flere',
		newsArticle: 'Nyhed',
	},
};

// Create VueI18n instance with options
Vue.use(VueI18n);

export const i18n = new VueI18n({
	locale: 'da', // set locale
	messages: translations, // set locale messages
});



// WEBPACK FOOTER //
// ./assets/_js/translation.js